import { EventActionType } from './event-action-type';
import { EventEntry } from '../../state';

export interface SetEventPosterImagesAction {
  eventKey: string;
  posterImages: EventEntry['event']['posterImages'];
  type: EventActionType.SetEventPosterImages;
}

export const setEventPosterImages = (
  eventKey: string,
  posterImages: EventEntry['event']['posterImages'],
): SetEventPosterImagesAction => ({
  eventKey,
  posterImages,
  type: EventActionType.SetEventPosterImages,
});
